export const isBrowserEnv = (): boolean => (
  !!(typeof window !== 'undefined' && window.document && window.document.createElement)
);
